const endpoint = 'https://fruitsale.jp';

export default {
  securityCode: endpoint + '/assets/security-code.png',
  banner_1: endpoint + '/assets/logo/banner_1%403x.png',
  banner_2: endpoint + '/assets/logo/banner_2%403x.png',
  banner_3: endpoint + '/assets/logo/banner_3%403x.png',
  banner_4: endpoint + '/assets/logo/banner_4%403x.png',
  logo_header: endpoint + '/assets/logo/logo.png',
  logo_header_mobile: endpoint + '/assets/logo/logo-header-mobile.png',
  logo_footer: endpoint + '/assets/logo/logo-white.png',
  facebookLogo: endpoint + '/assets/logo/logo%40facebook.png',
  googleLogo: endpoint + '/assets/logo/logo%40google.png',
  stripeLogo: endpoint + '/assets/logo/logo%40stripe.png',
};
